import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '../components/dashboard/Dashboard';
import UserRoutes from './UserRoutes';
import AssetRoutes from './AssetRoutes';
import CategoryRoutes from './CategoryRoutes';
import PurchaseHistoryRoutes from './PurchaseHistoryRoutes';
import ProtectedRoute from './ProtectedRoute';
import DepreciationRateRoutes from './DepreciationRateRoutes';
import Reports from '../components/reports/Reports';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute allowedRoles={['ADMIN', 'USER']}>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute allowedRoles={['ADMIN', 'USER']}>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/users/*" element={
        <ProtectedRoute allowedRoles={['ADMIN']}>
            <UserRoutes />
        </ProtectedRoute>} />
      <Route path="/assets/*" element={
        <ProtectedRoute allowedRoles={['ADMIN']}>
            <AssetRoutes />
        </ProtectedRoute>} />
      <Route path="/categories/*" element={
        <ProtectedRoute allowedRoles={['ADMIN']}>
            <CategoryRoutes />
        </ProtectedRoute>} />
      <Route path="/purchase-history/*" element={
        <ProtectedRoute allowedRoles={['ADMIN']}>
            <PurchaseHistoryRoutes />
        </ProtectedRoute>} />

         {/* 🔥 REPORTS PAGE */}
              <Route path="/reports" element={
                <ProtectedRoute allowedRoles={['ADMIN',"SUPER_ADMIN"]}>
                  <Reports />
                </ProtectedRoute>
              } />

      <Route path="/depreciation-rates/*" element={
        <ProtectedRoute allowedRoles={['ADMIN']}>
            <DepreciationRateRoutes />
        </ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes;